import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { InquiryProvider } from './contexts/InquiryContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ArtworkDetailPage from './pages/ArtworkDetailPage';
import InquiryPage from './pages/InquiryPage';
import AntipodismePage from './pages/AntipodismePage';
import SymboliekPage from './pages/SymboliekPage';
import ClemensBrielsPage from './pages/ClemensBrielsPage';

const App: React.FC = () => {
  return (
    <InquiryProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route path="/over-ons" component={AboutPage} />
            <Route path="/antipodisme" component={AntipodismePage} />
            <Route path="/symboliek" component={SymboliekPage} />
            <Route path="/artwork/:id" component={ArtworkDetailPage} />
            <Route path="/clemens-briels" component={ClemensBrielsPage} />
            <Route path="/aanvraag" component={InquiryPage} />
          </Switch>
          <Footer />
        </div>
      </Router>
    </InquiryProvider>
  );
};

export default App;